import React, { useEffect, useState } from 'react';
import { WebsocketEmitters } from '@common/app/socket';
import { socket } from '@common/socket/socket';
import { type ResourceTypeText } from '@common/types/resource';
import { resourceImages } from '@components/helpers/imagesImports';
import { AnimatePresence, motion } from 'framer-motion';

interface Message {
  id: string;
  materialName: ResourceTypeText;
  achieveValue: number;
  progress: number;
  text: string;
  positionY: number;
  opacity: number;
}

interface TaskProgressSocketData {
  achieveValue: number;
  materialName: ResourceTypeText;
  progress: number;
}

const MessageQueue: React.FC = () => {
  const [messages, setMessages] = useState<Message[]>([]);

  const title: Record<ResourceTypeText, string> = {
    wood: 'дерева',
    cotton: 'хлопок',
    bulk: 'сыпучих материалов',
    iron: 'железной руды',
    oil: 'нефти',
    precious: 'драгоценных металлов',
  };

  useEffect(() => {
    const addMessage = (
      achieveValue: number,
      materialName: ResourceTypeText,
      progress: number,
    ): Message | undefined => {
      if (achieveValue >= progress) {
        return;
      }
      const id = Math.random().toString(36).substring(2, 9);
      const text = `Задание "Натапать ${achieveValue}.ед ${title[materialName as ResourceTypeText]}" выполнено`;

      // if (achieveValue >= progress) {
      //   text = `Задание "Натапать ${achieveValue}.ед ${title[materialName as ResourceType]}" выполнено`;
      // } else {
      //   text = `Натапать ${title[materialName as ResourceType]}`;
      // }
      setMessages((prev) => {
        const updatedMessages = prev.map((el) => ({
          ...el,
          positionY: el.positionY + 37,
          opacity: parseFloat((el.opacity - 0.2).toFixed(1)),
        }));

        const newMessages = [
          ...updatedMessages,
          {
            id,
            materialName,
            progress,
            achieveValue,
            text,
            positionY: 0,
            opacity: 0.8,
          },
        ];

        if (newMessages.length > 3) {
          newMessages.shift();
        }

        return newMessages;
      });
      setTimeout(() => removeMessage(id), 3000);
    };

    const handleTaskProgress = <T extends TaskProgressSocketData>(
      data: T,
    ): void => {
      console.log('Task progress received:', data);

      const { achieveValue, materialName, progress } = data;
      addMessage(
        achieveValue as number,
        materialName as ResourceTypeText,
        progress,
      );
    };

    socket.on(WebsocketEmitters.TASK_PROGRESS, handleTaskProgress);

    return (): void => {
      socket.off(WebsocketEmitters.TASK_PROGRESS, handleTaskProgress);
    };
  }, []);

  const removeMessage = (id: string): void => {
    setMessages((prev) => prev.filter((msg) => msg.id !== id));
  };

  return (
    <div className="message-container">
      <div className="message-list">
        <AnimatePresence>
          {messages.map((message) => (
            <motion.div
              key={message.id}
              initial={{ opacity: 0, y: 0 }}
              animate={{ opacity: 1, y: -message.positionY }}
              exit={{ opacity: 0, y: -message.positionY - 30 }}
              transition={{ duration: 0.3 }}
              className="message"
              style={{
                background: `var(--main-80, rgba(24, 26, 32, ${message.opacity}))`,
              }}
            >
              <div className="message-main">
                <picture>
                  <source
                    srcSet={
                      message.materialName === 'wood'
                        ? resourceImages[message.materialName].icon.webpRight
                        : resourceImages[message.materialName].icon.webp
                    }
                    type="image/webp"
                  />
                  <img
                    src={
                      message.materialName === 'wood'
                        ? resourceImages[message.materialName].icon.pngRight
                        : resourceImages[message.materialName].icon.png
                    }
                    alt="resource"
                    width={32}
                  />
                </picture>
                <span className="message-text">{message.text}</span>
              </div>
              {/* <div className="message-values">
                <span>{message.progress}</span>
                <span style={{ color: 'var(--text-gray, #FFFFFF66)' }}>
                  /{message.achieveValue}
                </span>
              </div> */}
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default MessageQueue;
